import { firebaseConfig } from "@/infrastructure/firebase/config"
import { getApp, getApps, initializeApp } from "firebase/app"

export function getFirebaseApp() {
  const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

  return app
}
